module.exports = __webpack_public_path__ + "img/jab-logo.3932bd47.svg";